import { UtilitiesService } from './../../../services/utilities.service';
import { TrInputComponent } from './../tr-input/tr-input.component';
import { Component, TemplateRef, Output, Renderer2, EventEmitter, Input, ChangeDetectorRef, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { NgModel } from '@angular/forms';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Store } from '@ngrx/store';
import { AppState } from '../../../interfaces/app-state.interface';

@AutoUnsubscribe()
@Component({
    selector: "tr-autocomplete",
    templateUrl: "./tr-autocomplete.component.html",
    styleUrls: ["./tr-autocomplete.component.scss"],
    providers: [UtilitiesService],
})
export class TrAutoCompleteComponent
    extends TrInputComponent
    implements OnDestroy, AfterViewInit
{
    public asyncSelected: NgModel;
    public typeaheadLoading: boolean;
    public typeaheadNoResults: boolean;
    public dataSource: Observable<any>;
    public resultList: any;

    @Output() public foundValue: EventEmitter<string> = new EventEmitter();

    @Input() public type;
    @Input() public composeLabel;
    @Input() public filter;
    @Input() public removeAccents: boolean = false;
    @Input() public set dataList(data: any[]) {
        if (data && data.length) {
            this.dataListAux = data;
            this.setByID(this._id);
            if (this.acronym) {
                this.setByAcronym(this.acronym);
            }
        }
    }

    public get dataList() {
        return this.dataListAux;
    }

    @ViewChild("customItemTemplate", { static: true })
    public customItemTemplate: TemplateRef<any>;
    @ViewChild("formInput", { static: true }) public formInput: ElementRef;

    private dataListAux = [];
    private idComplete;
    private set _id(id) {
        this.idComplete = id;
    }

    private get _id() {
        return this.idComplete;
    }

    private acronym;

    constructor(
        public render: Renderer2,
        public utilitiesService: UtilitiesService,
        public changes: ChangeDetectorRef,
        store: Store<AppState>
    ) {
        super(store);

        this.dataList = [];

        this.dataSource = Observable.create((observer: any) => {
            observer.next(this.ValueInput);
        }).mergeMap((token: string) => this.getResultsAsObservable(token));
    }

    public ngAfterViewInit() {
        //
    }

    public ngAfterContentInit() {
        if (this.ControlReference.value) {
            this.setByID(this.ControlReference.value);
        }
    }

    public composeLabels(model): any {
        if (this.composeLabel) {
            const labels: any[] = this.composeLabel.labels;
            return Object.keys(model)
                .map((key) => {
                    if (labels.indexOf(key) > -1) {
                        return model[labels[labels.indexOf(key)]];
                    }
                })
                .filter((item) => item)
                .join(` ${this.composeLabel.separator} `);
        } else {
            return null;
        }
    }

    public getResultsAsObservable(
        token: string,
        exatMatch: boolean = false
    ): Observable<any> {
        this.changes.detectChanges();

        // REMOVE ACENTOS CASO NECESSÁRIO
        if (this.removeAccents) {
            token = this.utilitiesService.removeAccents(token).trim();
        }

        token = token.replace(/[^\w\s]/gi, "");

        // CRIA QUERY DE BUSCA
        const query = new RegExp(exatMatch ? `^${token}$` : `${token}`, "i");

        // CRIA QUERY DE FILTRO
        const queryFilter = this.filter
            ? new RegExp(`${this.filter.value}`, "i")
            : null;

        // REALIZA A BUSCA
        const save = this.filter
            ? this.searchQueryWithFilter(query, queryFilter)
            : this.searchQuery(query);

        this.resultList = save;

        return of(this.orderResults(save));
    }

    /**
     * Ordena os resultados do autocomplete
     * @param results
     */
    public orderResults(results): any[] {
        const resultsSorted = results.sort((item, next) => {
            // Determina o atributo que o item do datalist contem
            const key = item.name
                ? "name"
                : item.description
                ? "description"
                : "acronym";

            // Usar apenas lowercase para filtro e ordenação
            const itemStr = item[key].toLowerCase();
            const nextStr = next[key].toLowerCase();
            const filterStr = this.ValueInput.toLowerCase();

            // Determina o index da ocorrência de pesquisa
            const itemIndex = itemStr.indexOf(filterStr);
            const nextIndex = nextStr.indexOf(filterStr);

            // Ordena os resultados
            if (itemIndex > nextIndex) {
                return 1;
            } else if (itemIndex < nextIndex) {
                return -1;
            } else {
                return itemStr < nextStr ? -1 : 1;
            }
        });

        return resultsSorted;
    }

    public searchQueryWithFilter(query, queryFilter) {
        return this.dataList.filter((results: any) => {
            return (
                (query.test(results.name) ||
                    query.test(results.description) ||
                    query.test(results.acronym)) &&
                queryFilter.test(results[this.filter.type])
            );
        });
    }

    public searchQuery(query) {
        return this.dataList.filter((results: any) => {
            return (
                query.test(results.name) ||
                query.test(results.description) ||
                query.test(results.acronym)
            );
        });
    }

    public getIDAsObservable(token: number): Observable<any> {
        // CRIA QUERY DE BUSCA
        const query = new RegExp(`^${token}$`, "i");

        // REALIZA A BUSCA
        const save = this.dataList.filter((results: any) => {
            return query.test(results.id);
        });

        this.resultList = save;
        return of(save);
    }

    public getAcronymAsObservable(token: string): Observable<any> {
        // CRIA QUERY DE BUSCA
        const query = new RegExp(`^${token}$`, "i");

        // REALIZA A BUSCA
        const save = this.dataList.filter((results: any) => {
            return query.test(results.acronym);
        });

        this.resultList = save;
        return of(save);
    }

    /**
     * Muda o valor do controle durante o loading
     * @param e
     */
    public changeTypeaheadLoading(e: boolean): void {
        this.typeaheadLoading = e;
    }

    /**
     * Muda o valor do controle quando não tem um resultado
     * @param e
     */
    public changeTypeaheadNoResults(e: boolean): void {
        this.typeaheadNoResults = e;
        // this.ValueInput = null;
        const error = this.asyncSelected
            ? { [`${this.type}Error`]: true }
            : { required: true };
        this.ControlReference.setErrors(error);
    }

    /**
     * Seta o valor no controle dado um click do usuário na opção
     * @param e
     */
    public typeaheadOnSelect(e: TypeaheadMatch): void {
        this.selectValue(e.item);
    }

    /**
     * Seleciona pelo ID
     * @param value ID
     */
    public setByID(value: number): any {
        if (!this.dataList.length) {
            this._id = value;
            return;
        }
        this.filter = "";
        this.getIDAsObservable(value).subscribe((data) => {
            if (data.length === 1) {
                this.ValueInput = data[0].name || data[0].description;
                this.ControlReference.setValue(data[0].id, {
                    emitEvent: false,
                });
                // this.foundValue.emit(data[0]);
            }
        });
    }

    public setByMatch(value: string, success) {
        this.filter = "";
        this.getResultsAsObservable(value, true).subscribe((data) => {
            if (data.length === 1) {
                this.foundValue.emit(data[0]);
                this.ControlReference.setValue(data[0].id);
                this.asyncSelected = data[0].name || data[0].description;
                success(data[0].id);
            } else {
                this.ValueInput = null;
            }
        });
    }

    /**
     * Selecionar pelo acronimo
     * @param value acronimo
     */
    public setByAcronym(value: string): any {
        if (!this.dataList.length) {
            this.acronym = value;
            return;
        }
        this.filter = "";
        this.getAcronymAsObservable(value).subscribe((data) => {
            if (data.length === 1) {
                this.ValueInput = data[0].name || data[0].description;
                this.ControlReference.setValue(data[0].acronym, {
                    emitEvent: false,
                });
            }
        });
    }

    /**
     * Seleciona uma opção após tirar o foco do autocomplete
     */
    public selectOnBlur() {
        const value = this.dataList.find(
            (item) =>
                (this.ValueInput &&
                    item.description &&
                    (item.description.toUpperCase() as string).includes(
                        this.ValueInput.trim().toUpperCase()
                    )) ||
                (item.acronym &&
                    (item.acronym.toUpperCase() as string).includes(
                        this.ValueInput.trim().toUpperCase()
                    )) ||
                (item.name &&
                    (item.name.toUpperCase() as string).includes(
                        this.ValueInput.trim().toUpperCase()
                    ))
        );

        if (value) this.selectValue(value);
    }

    /**
     * Função para selecionar um valor corretamente,
     * preenchendo as propiedades corretamente
     * @param item Item que foi selecionado dentre as opções
     */
    public selectValue(item: any): void {
        this.ControlReference.setErrors(null);
        this.ControlReference.setValue(item.id);
        this.ValueInput = item.name || item.description;
    }

    /**
     * Função que reseta o valor do input
     */
    public resetValue() {
        this.ValueInput = "";
        this.ControlReference.reset();
    }

    public ngOnInit() {
        this.ControlReference.valueChanges.subscribe((e) => {
            if (e) this.setByID(e);
        });

        this.ControlReference.statusChanges.subscribe(() => {
            this.bindErrors();
        });
    }

    // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    public ngOnDestroy() {
        //
    }
}
